import React from 'react'
import PodiumAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/PodiumAppIcon'
import Typography from "housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography"
import Grid from "housecall-ui/dist/DesignSystem/Layout/Grid/Grid"
import PodiumButton from '../OtherComponents/PodiumButton';

const PodiumStrategy = {
  previewInfo: {
    name: 'Podium',
    newTab: true,
    iconSvg: <PodiumAppIcon size='xlarge' />,
  },
  headerInfo: {
    name: 'Podium',
    category: 'Reviews',
    details:
      'Podium is redefining the way customers interact with local businesses. Through its Interaction Management platform, ' +
      'businesses can message leads and customers, get reviews and feedback, and communicate easily with their teams. Podium was named as one of Forbes’ ' +
      'Next Billion-Dollar Startups and powers over 40,000 businesses.',
    iconSvg: <PodiumAppIcon size='xlarge' />,
  },
  media: {
    wistiaLink: 'https://view.highspot.com/viewer/5e4e9ab5f7794d443bd25117',
  },
  sellingPoints: {
    headline: 'Reduce missed appointments with Podium Automations.',
    unorderedPoints: [
      'Podium makes it easy to reduce missed appointment rates by automating appointment reminders and confirmations to keep your business running smoothly.',
      'Podium Automations integrates powerfully with Housecall Pro to do all the heavy lifting for you. Keep your customers in the loop with job updates and useful notifications along the way, all powered by text. Then once the job is done, Automations sends your customers an easy link to leave a review.',
      "Podium Automations frees up your staff to do other things. It's like another employee in your office that doesn't need snacks.",
    ],
    bottomDescription: null,
  },
  price: {
    price: '',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={8}>
          <Typography align='right' variant='body1'>
            Inquire for pricing
          </Typography>
        </Grid>
      </Grid>
    ),
    hideToggle: true,
    appActionButton: <PodiumButton />,
  },
  supportContacts: [{ type: 'Email', contact: 'sales@podium.com ' }, { type: 'Phone', contact: '833-276-3486' }],
}

export default PodiumStrategy
